exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".router-link-exact-active[data-v-9634ba1c]{font-weight:600;background-color:#2874a6;border:1px solid #2874a6}", ""]);

// exports
